module.exports = __webpack_public_path__ + "static/media/matt_about1.c6321fa4.jpg";